<template>
  <BusyArea :busy="loading">
    <div class="flex flex-wrap gap-x-10 gap-y-10 pb-10 pt-5">
      <div class="flex flex-col justify-stretch">
        <div class="text-body-regular-bold text-table-text-gray uppercase mb-5">
          {{ $t('pages.interestZone.statistic.title') }}
        </div>
        <table class="statisticsTable h-full">
          <thead>
            <tr>
              <th class="font-normal" />
              <th>{{ $t('pages.interestZone.statistic.total') }}</th>
              <th>{{ $t('pages.interestZone.statistic.filtered') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t(`pages.interestZone.statistic.${props.type}.count`) }}</td>
              <td>{{ formatNumber(statistics?.total?.count ?? 0) }}</td>
              <td>{{ formatNumber(statistics?.filtered?.count ?? 0) }}</td>
            </tr>
            <tr v-if="type === 'time'">
              <td>{{ $t(`pages.interestZone.statistic.time.sum`) }}</td>
              <td>{{ formatTimeDurationFromSeconds(statistics?.total?.sum ?? 0) }}</td>
              <td>{{ formatTimeDurationFromSeconds(statistics?.filtered?.sum ?? 0) }}</td>
            </tr>
            <tr v-else>
              <td>{{ $t(`pages.interestZone.statistic.distance.sum`) }}</td>
              <td>{{ statistics?.total?.sum ?? 0 }}</td>
              <td>{{ statistics?.filtered?.sum ?? 0 }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.interestZone.statistic.pointsSum') }}</td>
              <td>{{ formatNumber(statistics?.total?.points ?? 0) }}</td>
              <td>{{ formatNumber(statistics?.filtered?.points ?? 0) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </BusyArea>
</template>

<script setup lang="ts">
import BusyArea from '@utils/busy/BusyArea.vue';
import { formatNumber, formatTimeDurationFromSeconds } from '@/utils/helpers';

interface StatisticsItem {
  count: number;
  sum: number;
  points: number;
}

export interface Statistics {
  total: StatisticsItem;
  filtered: StatisticsItem;
}

interface Props {
  type: 'distance' | 'time';
  statistics: Statistics;
  loading?: boolean;
}

const props = defineProps<Props>();

console.log(props.statistics);

</script>

<style lang="scss" scoped>
.statisticsTable {
  @apply border;

  tr {
    td, th {
      &:not(:last-child) {
        @apply border-r;
      }
      @apply px-5 py-2;
      text-align: right;
    }

    th {
      @apply border-b;
    }

    &:last-child {
      td:not(:first-child) {
        border-top: 3px double black;
      }
    }
  }
}
</style>
